import conf from './_conf';
import { workName, emitUpload, updatePage } from './_upload';

export const emitEnter = name => {
  if (!conf[workName].enter[name]) return;
  let newPageName = conf[workName].enter[name].event;
  if (!newPageName) return;
  // 更新页面值
  updatePage(newPageName);
  // 触发进入页面上报
  emitUpload(`enter-${newPageName}`, conf[workName].enter[name]);
};

let saveActive = {};

export const emitActive = name => {
  if (!conf[workName].enter[name]) return;
  let newPageName = conf[workName].enter[name].event;
  if (!newPageName) return;
  if (!saveActive[newPageName]) {
    saveActive[newPageName] = true;
    return;
  }
  // 更新页面值
  updatePage(newPageName);
  // 触发进入页面上报
  emitUpload(`enter-${newPageName}`, conf[workName].enter[name]);
};
